//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";
import { validateEmail } from "@/utils/validations.js";
import BackendServices from "@/services/backend-services";

export default {
  name: "PortalCredentialManagerForm",
  components: {},
  props: ["selectedRow", "drawerMode"],
  mounted: async function () {
    this.formLoading = true;
    await this.requestFormData();
    this.formLoading = false;
    this.updateForm();
  },
  data() {
    return {
      validForm: false,
      credentialId: "",
      userName: "",
      password: "",
      passwordCheck: "",
      retailer: "",
      storeHierarchyId: "",
      availableStoreHierarchies: [],
      formLoading: false,
      passwordManager: false,
      isPwd: true,
      isPwd1: true,
      deleteConfirmMode: true,
    };
  },
  methods: {
    required,
    noValidation,
    validateEmail,
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    async requestFormData() {
      await BackendServices.getRetailers().then((response) => {
        this.availableStoreHierarchies = response.data;
      });

      // ask for insignias and add to availableStoreHierarchies
      await BackendServices.getInsignias().then((response) => {
        this.availableStoreHierarchies = [
          ...this.availableStoreHierarchies,
          ...response.data,
        ];
      });
    },
    updateData() {
      this.$emit("save-credential", {
        id: this.selectedRow.id,
        portal_credential: {
          user_name: this.userName,
          password: this.password,
          store_hierarchy_element_id: this.storeHierarchyId,
        },
      });
    },
    updateForm() {
      this.userName = this.selectedRow.user_name;
      this.password = this.selectedRow.password;
      this.retailer = this.selectedRow.retailer_name;
      this.storeHierarchyId = this.selectedRow.store_hierarchy_element_id;
      this.credentialId = this.selectedRow.id;
      this.passwordCheck = this.password;
    },
    deleteCredential() {
      this.$emit("delete-reg", this.selectedRow.id);
    },
    checkPassword() {
      if (this.password != this.passwordCheck) {
        this.$emit("valid-pwd", false);
      } else {
        this.$emit("valid-pwd", true);
      }
    },
  },
  //TODO Meter eficientemente os dados
  watch: {
    userName() {
      this.updateData();
    },
    password() {
      this.checkPassword();
      this.updateData();
    },
    passwordCheck() {
      this.checkPassword();
    },
    storeHierarchyId() {
      this.updateData();
    },
    selectedRow() {
      this.updateForm();
    },
  },
};
